import { render, staticRenderFns } from "./DBViewModal.vue?vue&type=template&id=6b201198&scoped=true"
import script from "./DBViewModal.vue?vue&type=script&lang=js"
export * from "./DBViewModal.vue?vue&type=script&lang=js"
import style0 from "./DBViewModal.vue?vue&type=style&index=0&id=6b201198&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b201198",
  null
  
)

export default component.exports